import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// 1. PIPELINE Images (Restored & Perfected)
import imgPip1 from "../../../assets/img/portfolio/pipeline/img-1.jpeg";
import imgPip2 from "../../../assets/img/portfolio/pipeline/img-2.jpeg";
import imgPip3 from "../../../assets/img/portfolio/pipeline/img-3.jpeg";
import imgPip4 from "../../../assets/img/portfolio/pipeline/img-4.jpeg";
import imgPip5 from "../../../assets/img/portfolio/pipeline/img-5.jpeg";
import imgPip6 from "../../../assets/img/portfolio/pipeline/img-6.jpeg";

// 2. RCC WALL Images
import imgRcc1 from "../../../assets/img/portfolio/road-1.jpeg";
import imgRcc2 from "../../../assets/img/portfolio/road-2.jpeg";
import imgRcc3 from "../../../assets/img/portfolio/road-3.jpeg";
import imgRcc4 from "../../../assets/img/portfolio/road-4.jpeg";
import imgRcc5 from "../../../assets/img/portfolio/road-5.jpeg";
import imgRcc6 from "../../../assets/img/portfolio/road-6.jpeg";

// 3. EARTH WORK Images
import imgEarth1 from "../../../assets/img/portfolio/earth-work/img-1.jpeg";
import imgEarth2 from "../../../assets/img/portfolio/earth-work/img-2.jpeg";
import imgEarth3 from "../../../assets/img/portfolio/earth-work/img-3.jpeg";
import imgEarth4 from "../../../assets/img/portfolio/earth-work/img-4.jpeg";
import imgEarth5 from "../../../assets/img/portfolio/earth-work/img-5.jpeg";
import imgEarth6 from "../../../assets/img/portfolio/earth-work/img-6.jpeg";

// 4. COMPOUND WALL Images
import imgComp1 from "../../../assets/img/portfolio/compound-wall/img-1.jpeg";
import imgComp2 from "../../../assets/img/portfolio/compound-wall/img-2.jpeg";
import imgComp3 from "../../../assets/img/portfolio/compound-wall/img-3.jpeg";
import imgComp4 from "../../../assets/img/portfolio/compound-wall/img-4.jpeg";
import imgComp5 from "../../../assets/img/portfolio/compound-wall/img-5.jpeg";
import imgComp6 from "../../../assets/img/portfolio/compound-wall/img-6.jpeg";

// 5. D-WATERING Images
import imgDwat1 from "../../../assets/img/portfolio/d-watering/img-1.jpeg";
import imgDwat2 from "../../../assets/img/portfolio/d-watering/img-2.jpeg";
import imgDwat3 from "../../../assets/img/portfolio/d-watering/img-3.jpeg";
import imgDwat4 from "../../../assets/img/portfolio/d-watering/img-4.jpeg";
// import imgDwat5 from "../../../assets/img/portfolio/d-watering/img-5.jpeg";
// import imgDwat6 from "../../../assets/img/portfolio/d-watering/img-6.jpeg";

// 6. PITCHING WORK Images
import imgPitch1 from "../../../assets/img/portfolio/pitching/img-1.jpeg";
import imgPitch2 from "../../../assets/img/portfolio/pitching/img-2.jpeg";
import imgPitch3 from "../../../assets/img/portfolio/pitching/img-3.jpeg";
import imgPitch4 from "../../../assets/img/portfolio/pitching/img-4.jpeg";
import imgPitch5 from "../../../assets/img/portfolio/pitching/img-5.jpeg";
import imgPitch6 from "../../../assets/img/portfolio/pitching/img-6.jpeg";

// --- Filters Setup ---
const filters = [
    { id: 1, name: "All Projects", filterData: "all" },
    { id: 2, name: "Earth Work", filterData: "earth-work" },
    { id: 3, name: "Pipeline", filterData: "pipeline" },
    { id: 4, name: "RCC Wall", filterData: "rcc-wall" },
    { id: 5, name: "Compound Wall", filterData: "compound-wall" },
    { id: 6, name: "D-Watering", filterData: "d-watering" },
    { id: 7, name: "Pitching Work", filterData: "pitching" },
];

// --- Complete Data Array ---
const customPortfolioData = [
    // --- PIPELINE CATEGORY (6 items) ---
    { id: "drainage-line-1", image: imgPip1, title: "Main Drainage Line", subtitle: "Pipeline", category: "pipeline" },
    { id: "underground-pipe", image: imgPip2, title: "Underground Pipeline", subtitle: "Pipeline", category: "pipeline" },
    { id: "water-supply", image: imgPip3, title: "Water Supply Setup", subtitle: "Pipeline", category: "pipeline" },
    { id: "sewerage-network", image: imgPip4, title: "Sewerage Network", subtitle: "Pipeline", category: "pipeline" },
    { id: "storm-water", image: imgPip5, title: "Storm Water Drain", subtitle: "Pipeline", category: "pipeline" },
    { id: "irrigation-pipe", image: imgPip6, title: "Irrigation Pipeline", subtitle: "Pipeline", category: "pipeline" },

    // --- RCC WALL CATEGORY (6 items) ---
    { id: "rcc-retaining-wall", image: imgRcc1, title: "RCC Retaining Wall", subtitle: "RCC Wall", category: "rcc-wall" },
    { id: "rcc-boundary-wall", image: imgRcc2, title: "RCC Boundary Wall", subtitle: "RCC Wall", category: "rcc-wall" },
    { id: "rcc-structure", image: imgRcc3, title: "Heavy RCC Structure", subtitle: "RCC Wall", category: "rcc-wall" },
    { id: "rcc-foundation", image: imgRcc4, title: "RCC Foundation Wall", subtitle: "RCC Wall", category: "rcc-wall" },
    { id: "rcc-protection", image: imgRcc5, title: "RCC Protection Wall", subtitle: "RCC Wall", category: "rcc-wall" },
    { id: "rcc-basement", image: imgRcc6, title: "RCC Basement Wall", subtitle: "RCC Wall", category: "rcc-wall" },

    // --- EARTH WORK CATEGORY (6 items) ---
    { id: "site-clearance", image: imgEarth1, title: "Site Clearance & Leveling", subtitle: "Earth Work", category: "earth-work" },
    { id: "mass-excavation", image: imgEarth2, title: "Mass Excavation", subtitle: "Earth Work", category: "earth-work" },
    { id: "trenching", image: imgEarth3, title: "Trenching Work", subtitle: "Earth Work", category: "earth-work" },
    { id: "backfilling", image: imgEarth4, title: "Soil Backfilling", subtitle: "Earth Work", category: "earth-work" },
    { id: "embankment", image: imgEarth5, title: "Embankment Creation", subtitle: "Earth Work", category: "earth-work" },
    { id: "compaction", image: imgEarth6, title: "Soil Compaction", subtitle: "Earth Work", category: "earth-work" },

    // --- COMPOUND WALL CATEGORY (6 items) ---
    { id: "residential-compound", image: imgComp1, title: "Residential Compound", subtitle: "Compound Wall", category: "compound-wall" },
    { id: "industrial-boundary", image: imgComp2, title: "Industrial Boundary", subtitle: "Compound Wall", category: "compound-wall" },
    { id: "precast-compound", image: imgComp3, title: "Precast Compound Wall", subtitle: "Compound Wall", category: "compound-wall" },
    { id: "security-wall", image: imgComp4, title: "High Security Wall", subtitle: "Compound Wall", category: "compound-wall" },
    { id: "decorative-boundary", image: imgComp5, title: "Decorative Boundary", subtitle: "Compound Wall", category: "compound-wall" },
    { id: "estate-fencing", image: imgComp6, title: "Estate Fencing Wall", subtitle: "Compound Wall", category: "compound-wall" },

    // --- D-WATERING CATEGORY (6 items) ---
    { id: "trench-d-watering", image: imgDwat1, title: "Trench D-Watering", subtitle: "D-Watering", category: "d-watering" },
    { id: "well-point-system", image: imgDwat2, title: "Well Point System", subtitle: "D-Watering", category: "d-watering" },
    { id: "deep-well-pumping", image: imgDwat3, title: "Deep Well Pumping", subtitle: "D-Watering", category: "d-watering" },
    { id: "surface-water-control", image: imgDwat4, title: "Surface Water Control", subtitle: "D-Watering", category: "d-watering" },
    // { id: "foundation-drainage", image: imgDwat5, title: "Foundation Drainage", subtitle: "D-Watering", category: "d-watering" },
    // { id: "flood-mitigation", image: imgDwat6, title: "Site Flood Mitigation", subtitle: "D-Watering", category: "d-watering" },

    // --- PITCHING WORK CATEGORY (6 items) ---
    { id: "stone-pitching", image: imgPitch1, title: "Stone Pitching", subtitle: "Pitching Work", category: "pitching" },
    { id: "canal-lining", image: imgPitch2, title: "Canal Lining", subtitle: "Pitching Work", category: "pitching" },
    { id: "slope-protection", image: imgPitch3, title: "Slope Protection", subtitle: "Pitching Work", category: "pitching" },
    { id: "river-bank-pitching", image: imgPitch4, title: "River Bank Pitching", subtitle: "Pitching Work", category: "pitching" },
    { id: "dry-rubble-pitching", image: imgPitch5, title: "Dry Rubble Pitching", subtitle: "Pitching Work", category: "pitching" },
    { id: "embankment-pitching", image: imgPitch6, title: "Embankment Pitching", subtitle: "Pitching Work", category: "pitching" }
];

const PortfolioFilter = () => {
    const [filter, setFilter] = useState("all");
    
    const getFilteredProjects = (filterData) => {
        if (filterData === "all") {
            return customPortfolioData;
        }
        return customPortfolioData.filter((project) => project.category === filterData);
    };

    const filteredProjects = getFilteredProjects(filter);
    
    return (
        <div className="gallery__area four__columns section-padding">
            <div className="container">
                {/* Filter Buttons */}
                <div className="row">
                    <div className="col-xl-12 mb-40">
                        <div className="gallery__area-button t-center" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                            {filters.map(({ id, name, filterData }) => (
                                <button 
                                    key={id} 
                                    onClick={() => setFilter(filterData)}
                                    className={filter === filterData ? "active" : ""}
                                    style={{ padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer', transition: '0.3s' }}
                                >
                                    {name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                
                {/* Render Filtered Projects */}
                <div className="row">
                    {filteredProjects.map((data, id) => (
                        <div className="col-xl-4 col-md-6 mt-25" key={id}>
                            <div className="portfolio__four-item">
                                <Link to={`/portfolio/${data.id}`}><i className="flaticon flaticon-right-up"></i></Link>
                                <img src={data.image} alt={data.title} style={{ width: '100%', height: '300px', objectFit: 'cover', borderRadius: '8px' }} />
                                <div className="portfolio__four-item-content">
                                    <span>{data.subtitle}</span>
                                    <h5><Link to={`/portfolio/${data.id}`}>{data.title}</Link></h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PortfolioFilter;